import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import {
  FormControl,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
} from '@mui/material';
import SingleUserRow from 'components/molecules/FollowModal/SingleUserRow';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: '#292739',
  boxShadow: 24,
  p: 3,
  borderRadius: '25px',
  color: 'white',
  display: 'flex',

  justifyContent: 'center',
  flexDirection: 'column',
};

interface IInviteCreators {
  children: JSX.Element;
  setInvitedUser: React.SetStateAction<any>;
  setSplitPercentage: React.SetStateAction<any>;
}

export default function InviteCreators({
  children,
  setInvitedUser,
  setSplitPercentage,
}: IInviteCreators) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const authState = useAppSelector(selectAuth);
  const user0 = require('assets/Profile/buku_default_avatar.png');

  return (
    <div>
      <span onClick={handleOpen}>{children}</span>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <IconButton
            sx={{ position: 'absolute', right: 20, top: 20 }}
            onClick={handleClose}
          >
            <CloseIcon sx={{ color: 'white' }} />
          </IconButton>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Invite Creators
          </Typography>
          <FormControl>
            <TextField
              placeholder="0%"
              required
              sx={{
                maxWidth: '200px',
                alignSelf: 'center',
                width: '100%',
                marginTop: '20px',
                input: {
                  color: 'white',
                  fontSize: '15px',
                  paddingX: '10px',
                  width: '100%',
                },
              }}
              onChange={e => setSplitPercentage(e.target.value)}
              type="number"
              id="input-with-icon-textfield"
              InputProps={{
                inputProps: { min: 0, max: 90 },
                startAdornment: (
                  <InputAdornment position="start">
                    <span style={{ color: 'white', fontSize: '15px' }}>
                      Split Percentage
                    </span>
                  </InputAdornment>
                ),
              }}
              variant="standard"
              color="info"
            />
          </FormControl>
          <Stack sx={{ marginTop: '15px' }} direction="column" spacing={2}>
            {authState.following
              ?.filter(following => following.following.canPost)
              .map((following, index) => (
                <SingleUserRow
                  key={index}
                  avatarSrc={following.following.avatar || user0}
                  username={following.following.username}
                  userId={following.following.id}
                  data={following.following}
                  isPost={true}
                  setUser={setInvitedUser}
                />
              ))}
          </Stack>
        </Box>
      </Modal>
    </div>
  );
}
